import { Dispatch, SetStateAction, useState } from "react";

export default function useLocalStorage<S>(
    key: string,
    initialValue?: S | (() => S),
): [S, Dispatch<SetStateAction<S>>] {
    const [storedValue, setStoredValue] = useState(() => {
        const initialState = initialValue instanceof Function ? initialValue() : initialValue;
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : initialState;
        } catch (error) {
            console.log(error);
            return initialState;
        }
    });

    function storeValue(value: SetStateAction<S>) {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.log(error);
        }
    }

    return [storedValue, storeValue];
}
